import type { ErrorTranslations } from "./utils";

export default {
  file_type_not_supported: {
    EN: "File type is not supported",
    RO: "Tipul fisierului nu este suportat",
  },
  file_not_found: {
    EN: "File was not found",
    RO: "Fisierul nu a fost gasit",
  },
} satisfies ErrorTranslations;
